module.exports = require('crypto');


//////////////////
// WEBPACK FOOTER
// ./~/randomhex/src/crypto.js
// module id = 4c6f
// module chunks = 0